import { useState } from 'react';
import { X, Plus, Phone, FileText, Store, Receipt, Download, FileSpreadsheet } from 'lucide-react';
import { money, http } from '../lib/api';
import { InvoiceList } from './Lists';

function Statement({ wholesaler }) {
  const year = new Date().getFullYear();
  const [start, setStart] = useState(`${year}-01-01`);
  const [end, setEnd] = useState(new Date().toISOString().slice(0, 10));
  const [busy, setBusy] = useState('');
  const download = async (format) => {
    setBusy(format);
    try {
      const r = await http.get(`/export/wholesaler/${wholesaler.id}`, { params: { format, start, end }, responseType: 'blob' });
      const url = URL.createObjectURL(r.data);
      const a = Object.assign(document.createElement('a'), { href: url, download: `ekstre-${wholesaler.name.replace(/\s+/g, '-')}-${start}_${end}.${format}` });
      document.body.appendChild(a); a.click(); a.remove(); URL.revokeObjectURL(url);
    } finally { setBusy(''); }
  };
  return <div className="statement-box" data-testid="wholesaler-statement">
    <div><strong>Toptancı ekstresi</strong><span>Seçilen dönemdeki faturalar ve ödeme durumu</span></div>
    <div className="statement-range">
      <label>Başlangıç<input type="date" value={start} onChange={(e) => setStart(e.target.value)} data-testid="statement-start-input" /></label>
      <label>Bitiş<input type="date" value={end} onChange={(e) => setEnd(e.target.value)} data-testid="statement-end-input" /></label>
    </div>
    <div className="statement-actions">
      <button type="button" className="secondary-btn" disabled={!!busy} onClick={() => download('pdf')} data-testid="statement-pdf-button"><Download size={15} /> PDF ekstre</button>
      <button type="button" className="secondary-btn" disabled={!!busy} onClick={() => download('xlsx')} data-testid="statement-xlsx-button"><FileSpreadsheet size={15} /> Excel ekstre</button>
    </div>
  </div>;
}

export function WholesalerDetail({ wholesaler, invoices = [], onClose, onAddInvoice, onToggle, onEdit, onDelete }) {
  const rows = [...invoices].sort((a, b) => a.status === b.status ? a.due_date.localeCompare(b.due_date) : a.status === 'unpaid' ? -1 : 1);
  const unpaid = rows.filter(x => x.status === 'unpaid');
  return <div className="drawer-backdrop" onClick={onClose}><aside className="drawer" onClick={(e) => e.stopPropagation()} data-testid="wholesaler-detail">
    <div className="drawer-head">
      <div className="entity-icon"><Store size={18} /></div>
      <div className="drawer-title"><span className="eyebrow">TOPTANCI</span><h2 data-testid="wholesaler-detail-name">{wholesaler.name}</h2><p>{wholesaler.contact_person}{wholesaler.phone ? <> · <Phone size={10} /> {wholesaler.phone}</> : ''}{wholesaler.tax_info ? ` · VKN ${wholesaler.tax_info}` : ''}</p></div>
      <button type="button" className="icon-btn" onClick={onClose} data-testid="wholesaler-detail-close"><X size={18} /></button>
    </div>
    <div className="drawer-stats">
      <div><span>Cari bakiye</span><strong>{money(wholesaler.balance)}</strong></div>
      <div><span>Ödenmemiş fatura</span><strong className="text-danger" data-testid="wholesaler-unpaid-total">{money(unpaid.reduce((a, x) => a + x.amount, 0))}</strong><small>{unpaid.length} fatura</small></div>
      <div><span>Toplam fatura</span><strong>{rows.length}</strong></div>
    </div>
    {wholesaler.notes && <div className="drawer-note"><FileText size={13} /> {wholesaler.notes}</div>}
    <Statement wholesaler={wholesaler} />
    <div className="drawer-section-head"><h3><Receipt size={15} /> Gelen faturalar</h3><button type="button" className="primary-btn" onClick={onAddInvoice} data-testid="wholesaler-add-invoice-button"><Plus size={16} /> Fatura ekle</button></div>
    {rows.length === 0 ? <div className="empty-state" data-testid="wholesaler-invoices-empty">Bu toptancıya ait fatura yok. Telefonunuzdan fotoğraf çekip ilk faturayı ekleyin.</div>
      : <InvoiceList rows={rows} compact prefix="wholesaler-invoices" onToggle={onToggle} onEdit={onEdit} onDelete={onDelete} />}
  </aside></div>;
}
